import React from "react";
import InfoTip from "../components/InfoTip";

function PortalFieldInfo({ children, label = "More info" }) {
  return <InfoTip label={label}>{children}</InfoTip>;
}

export default PortalFieldInfo;
